import Vue from 'vue'
import Vuex from 'vuex'
import networks from './networks'
import regions from './regions'
import auth from './auth'
import plans from './plans'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
  modules: {
    networks,
    regions,
    plans,
    auth
  },
  strict: debug
})

export default store
